<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { api, clientSettings } from '../../../stores/api.js';
    import { LocationApi } from './LocationApi.js';
    import { ConnectionApi } from '../Connection/ConnectionApi.js';
    import { get } from 'svelte/store';
    import FormSection from './FormSection.svelte';
    import FormRow from './FormRow.svelte';
    import SuccessInline from '../../shared/SuccessInline.svelte';
    import TemplateExpandedSection from './TemplateExpandedSection.svelte';
    import IconLocationOn from '../../shared/Icons/IconLocationOn.svelte';
    import ErrorColor from '../../shared/ErrorColor.svelte';
    import Label from './Label.svelte';
    import InputText from '../../shared/InputText.svelte';
    import SelectHour from '../../shared/SelectHour.svelte';
    import TemplateExpandedSectionButtons from './TemplateExpandedSectionButtons.svelte';
    import Spinner from '../../shared/Spinner/Spinner.svelte';
    import ErrorInline from '../../shared/ErrorInline.svelte';
    import ButtonSmallBlack from '../../shared/ButtonSmallBlack.svelte';
    import SelectDay from '../../shared/SelectDay.svelte';
    import { Location } from './Location';
    import { debug, defaultPageLink, mainMenu, onMapLoaded, planning } from '../../../stores/store';
    import { jobInitialData } from './jobInitialData';
    import { LocationRequestSchema, type LocationRequestType, LocationResponseSchema, type LocationResponseType } from './types.js';
    import SearchForm from '../../shared/SearchForm.svelte';
    import VehicleOneLabel from '../Vehicles/VehicleOneLabel.svelte';
    import VehicleOneParagraph from '../Vehicles/VehicleOneParagraph.svelte';
    import VehicleOneSection from '../Vehicles/VehicleOneSection.svelte';
    import VehicleOneValue from '../Vehicles/VehicleOneValue.svelte';
    import Checkbox from '../../shared/Checkbox/Checkbox.svelte';
    import Select from '../../shared/Select.svelte';
    import ButtonMain from '../../shared/ButtonMain.svelte';
    import ButtonSecondary from '../../shared/ButtonSecondary.svelte';
    import ButtonSmallBlue from '../../shared/ButtonSmallBlue.svelte';
    import MessageDangerSmall from '../../shared/Messages/MessageDangerSmall.svelte';
    import TemplateRow from '../../shared/TemplateRow.svelte';
    import { extractFieldsFromB } from '../../utilities/SchemaManager.js';
    import { getJobLabel, getJobPin, JobsOnMap } from './JobsOnMap';
    import { JobOnMap } from './JobOnMap';
    import { onMount } from 'svelte';
    import { onMapReady } from '../../utilities/onMapReady';
    import IconRemove from '../../shared/Icons/IconRemove.svelte';
    import IconRemoveFilter from '../../shared/Icons/IconRemoveFilter.svelte';
    import InputNumber from '../../shared/InputNumber.svelte';
    import { ResolutionTime } from '../telematics/components/Colorizer/ResolutionTime';
    import { ResolutionDate } from '../telematics/components/Colorizer/ResolutionDate';
    import IconPending from '../../shared/Icons/IconPending.svelte';
    import { JobValidator } from './JobValidator';
    import ErrorBounduary from './ErrorBounduary.svelte';
    import { BalloonContentGenerator } from '../../shared/BalloonContentGenerator';
    import { Navigation } from '../../utilities/Navigation';
    import { NotificationSystem } from '../NotificationSystem/NotificationSystem';
    import { app } from '../../../stores/app';
    import type { Api } from '@automapa/svelte-automapa-template';
    import { GeocodeSimpleApi, type GeocodeSimpleResponseType } from '../../utilities/GeocodeSimpleApi';
    import { getItemsFromLocationTypes } from '../../utilities/getItemsFromLocationTypes';
    import { Umami } from '../../utilities/Umami';

    export let job: Location;
    export let startPointOnMap: () => void;
    export let jobOnMap: JobOnMap;
    export let jobGeocodedOnMap: JobOnMap;
    export let triedToSave: boolean = false;

    let savingError: string = '';
    let validateError: string[] = [];
    let validating: boolean = false;
    let saving: boolean = false;
    let loading: boolean = true;
    let geocodingInProgress: boolean = false;

    let savedData: Location = new Location();

    let savedWithSuccess: boolean = false;
    let locationTypesItems: { id: string; label: string }[] = [];

    let isExtIdValid = true;
    let isFullNameValid = true;
    let isLocationTypeValid = true;

    // const defaultlocationTypes = [
    //     { id: 'delivery', label: 'delivery' },
    //     { id: 'collection', label: 'collection' },
    // ];

    function fillWithExampleData() {
        // job.setTargetDate($planning.selectedDay);

        job.getData().address_attributes = {
            country: 'PL',
            city: 'Warszawa',
            pcode: '00-001',
            street: 'Marszałkowska',
            house: '1',
            community: 'Śródmieście',
            province: 'mazowieckie',
            quarter: 'Stare Miasto',
        };

        job = job;
    }

    function fillWithSavedData() {
        triedToSave = false;
        job.set(JSON.parse(JSON.stringify(savedData.getData())));
        job.getData().id = -1;
        job = job;
    }

    async function validate(job: Location): Promise<boolean> {
        console.log('Validating job', job.getData());

        validateError = [];
        validating = true;

        let res1 = await JobValidator.checkUniqueExtId($api, job);
        if (res1 !== '') {
            validateError.push(res1);
            isExtIdValid = false;
            // return false;
        } else {
            isExtIdValid = true;
        }

        let res2 = await JobValidator.checkUniqueFullName($api, job, $app.settingsReadonly?.ext_id_must_exists_in_full_name === true);
        if (res2 !== '') {
            validateError.push(res2);
            isFullNameValid = false;
        } else {
            isFullNameValid = true;
        }

        // if (!JobValidator.checkCityNotEmpty(job)) {
        //     validateError.push('City cannot be empty');
        //     // return false;
        // }

        // if (!JobValidator.checkStreetNotEmpty(job)) {
        //     validateError.push('Street cannot be empty');
        //     // return false;
        // }

        if (!JobValidator.checkExtIdIsNotEmpty(job)) {
            validateError.push('Ext id cannot be empty');
            // return false;
        }

        if (!JobValidator.checkFullNameIsNotEmpty(job) && $app.settingsReadonly?.ext_id_must_exists_in_full_name === true) {
            validateError.push('Full name cannot be empty');
            // return false;
        }

        if (!JobValidator.checkExtIdIsPartOfFullName(job)) {
            validateError.push('Ext id must be part of full name');
            // return false;
        }

        if (!JobValidator.checkLocationTypeIsNotEmpty(job)) {
            validateError.push('Location type cannot be empty');
            isLocationTypeValid = false;
            // return false;
        } else {
            isLocationTypeValid = true;
        }

        validating = false;
        return validateError.length === 0;
    }

    function geocode() {
        validateError = [];
        geocodingInProgress = true;
        GeocodeSimpleApi.geocode($api, {
            address: {
                country: job.getData()?.address_attributes?.country || 'PL',
                city: job.getData()?.address_attributes?.city || '',
                street: job.getData()?.address_attributes?.street || '',
                house: job.getData()?.address_attributes?.house || '',
                pcode: job.getData()?.address_attributes?.pcode || '',
                province: job.getData()?.address_attributes?.province || '',
                community: job.getData()?.address_attributes?.community || '',
            },
        })
            .then((response: GeocodeSimpleResponseType) => {
                console.log('Geocode response', response);
                let x = response.output.x;
                let y = response.output.y;
                if (x !== null && y !== null) {
                    job.setCoords(x, y);
                    job = job;
                    jobGeocodedOnMap.addPoint(x, y, '#cccccc', new BalloonContentGenerator(job).getBalloonHtmlArray().join(''));
                    jobGeocodedOnMap.centerMap();
                }
            })
            .catch(err => {
                console.error('Error geocoding', err);
                validateError = [];
                validateError.push('error_geocoding');
            })
            .finally(() => {
                geocodingInProgress = false;
            });
    }

    async function saveJob() {
        saving = true;
        triedToSave = true;
        savingError = '';
        console.log('saveJob1, location_type', job.getLocationType());
        let jobRequest: LocationRequestType = extractFieldsFromB<LocationRequestType>(job.getData(), LocationRequestSchema);
        console.log('saveJob2, location_type', jobRequest?.location_type);
        try {
            LocationRequestSchema.parse(jobRequest);
        } catch (e) {
            console.error('Error validating job request', e);
            savingError = e?.message || 'Error validating job request';
            return;
        }

        const isNew = (job.getData()?.id ?? 0) < 0;
        let createOrUpdate =
            job.getData()?.id < 0
                ? LocationApi.createOne(get(api), jobRequest)
                : LocationApi.updateOne(get(api), job.getData()?.id, jobRequest);
        let savedJob = await createOrUpdate.catch(err => {
            console.error('Error saving job', err);
            savingError = err;
            Umami.error(isNew ? 'job_created' : 'job_edited', err);
        });

        console.log('saveJob3, savedJob, location_type', savedJob?.location_type);

        if (savedJob) {
            job.set(savedJob);
            if (job.hasCoords()) {
                let x = job.getX();
                let y = job.getY();
                if (x !== null && y !== null) {
                    if (!job.isManuallySetCoords()) {
                        jobOnMap.addPoint(x, y, '#70a0ff', new BalloonContentGenerator(job).getBalloonHtmlArray().join(''));
                        jobOnMap.centerMap();
                    }
                    jobGeocodedOnMap.addPoint(x, y, '#cccccc', new BalloonContentGenerator(job).getBalloonHtmlArray().join(''));
                    jobGeocodedOnMap.centerMap();
                }
            }
            job = job;
            savedData.set(JSON.parse(JSON.stringify(job.getData())));
            savedData = savedData;
            $NotificationSystem.reload();
            Umami.event(isNew ? 'job_created' : 'job_edited', { job_id: savedJob.id });
            if (isNew) {
                $mainMenu.items.find(item => item.id === 'PageJobs').notification.reload = true;
                $mainMenu = $mainMenu;
            }
        }

        saving = false;

        console.log('Saving job', job);
    }

    onMount(() => {
        Promise.all([LocationApi.getLocationTypes(get(api)), onMapReady()])
            .then(response => {
                locationTypesItems = getItemsFromLocationTypes(response[0]);
                if (job.hasCoords()) {
                    let x = job.getX();
                    let y = job.getY();
                    if (x !== null && y !== null) {
                        jobOnMap.addPoint(x, y, '#70a0ff', 'Punkt');
                        jobOnMap.centerMap();
                    }
                }
                loading = false;
            })
            .catch(e => {
                console.error('Error loading map', e);
            });

        return () => {
            jobOnMap.clear();
            jobGeocodedOnMap.clear();
        };
    });

    $: {
        (async () => {
            await validate(job);
        })();
    }

    $: {
        savedWithSuccess = triedToSave && !saving && !savingError && validateError.length === 0;

        if (savedWithSuccess) {
            Navigation.navigate(defaultPageLink);
        }
    }
</script>

{#if loading}
    <Spinner />
{:else}
    <div class="job-edit-form">
        {#if $debug}
            <ButtonSmallBlack text="Fill with example data" on:click={fillWithExampleData} />
        {/if}

        {#if job.getData()?.id < 0 && savedData && savedData.getData()?.id >= 0}
            <div style="margin:0 40px; display: flex; justify-content: flex-end; align-items: center;">
                <ButtonSmallBlack text={$_('Use saved data')} on:click={fillWithSavedData} />
            </div>
        {/if}

        <VehicleOneParagraph>
            <div slot="title">{$_('Point description')}</div>
            <div slot="content">
                <VehicleOneSection>
                    <VehicleOneLabel>
                        {$app.settingsReadonly?.short_name_instead_of_unique_id ? $_('ext_id') + '*' : $_('Unique id') + '*'}
                    </VehicleOneLabel>
                    <VehicleOneValue>
                        <InputText
                            value={job.getData()?.ext_id}
                            valid={isExtIdValid}
                            on:change={e => {
                                job.getData().ext_id = e.target?.value || '';
                                job = job;
                                validate(job);
                                return true;
                            }}
                        />
                    </VehicleOneValue>
                </VehicleOneSection>
                <VehicleOneSection>
                    <VehicleOneLabel>
                        {$_('full_name') + ($app.settingsReadonly?.ext_id_must_exists_in_full_name ? '*' : '')}
                    </VehicleOneLabel>
                    <VehicleOneValue>
                        <InputText
                            value={job.getData()?.full_name}
                            valid={isFullNameValid}
                            on:change={e => {
                                job.getData().full_name = e.target?.value || '';
                                job = job;
                                validate(job);
                                return true;
                            }}
                        />
                    </VehicleOneValue>
                </VehicleOneSection>
                <VehicleOneSection>
                    <VehicleOneLabel>
                        {$_('location_type') + '*'}
                    </VehicleOneLabel>
                    <VehicleOneValue>
                        <Select
                            selected={job.getLocationType() || ''}
                            valid={isLocationTypeValid}
                            items={locationTypesItems}
                            onChange={newValue => {
                                console.log('newValue', newValue);
                                job.getData().location_type = newValue || '';
                                console.log('location_type', job.getLocationType());
                                job = job;
                                return true;
                            }}
                        />
                        <!--<InputText
                            value={job.getLocationType() || ''}
                            valid={JobValidator.checkLocationTypeIsNotEmpty(job)}
                            on:change={e => {
                                job.getData().location_type = e.target?.value || '';
                                // job.updateSpecialAttributeValue(
                                //     'location_type',
                                //     e.target?.value || ''
                                // );
                                console.log('location_type', job.getLocationType());
                                job = job;
                                return true;
                            }}
                        />-->
                    </VehicleOneValue>
                </VehicleOneSection>
            </div>
        </VehicleOneParagraph>

        <VehicleOneParagraph>
            <div slot="title">{$_('Adres')}</div>
            <div slot="content" style="flex-direction: row;">
                <VehicleOneSection>
                    <VehicleOneLabel>
                        {$_('City')}
                    </VehicleOneLabel>
                    <VehicleOneValue>
                        <InputText
                            valid={true || JobValidator.checkCityNotEmpty(job)}
                            style="width: 100%; max-width: 220px;"
                            value={job.getData()?.address_attributes?.city || ''}
                            on:change={e => {
                                job.updateAddressAttributeValue('city', e.target?.value || '');
                                job = job;
                            }}
                            on:focusout={e => {
                                job.updateAddressAttributeValue('city', e.target?.value || '');
                                job = job;
                            }}
                        />
                    </VehicleOneValue>
                </VehicleOneSection>

                <VehicleOneSection>
                    <VehicleOneLabel>
                        {$_('Street')}
                    </VehicleOneLabel>
                    <VehicleOneValue>
                        <InputText
                            valid={true || JobValidator.checkStreetNotEmpty(job)}
                            style="width: 100%; max-width: 220px;"
                            value={job.getData()?.address_attributes?.street || ''}
                            on:change={e => {
                                job.updateAddressAttributeValue('street', e.target?.value || '');
                                job = job;
                            }}
                            on:focusout={e => {
                                job.updateAddressAttributeValue('street', e.target?.value || '');
                                job = job;
                            }}
                        />
                    </VehicleOneValue>
                </VehicleOneSection>

                <VehicleOneSection>
                    <VehicleOneLabel>
                        {$_('House')}
                    </VehicleOneLabel>
                    <VehicleOneValue>
                        <InputText
                            style="width: 100%; max-width: 220px;"
                            value={job.getData()?.address_attributes?.house || ''}
                            on:change={e => {
                                job.updateAddressAttributeValue('house', e.target?.value || '');
                                job = job;
                            }}
                            on:focusout={e => {
                                job.updateAddressAttributeValue('house', e.target?.value || '');
                                job = job;
                            }}
                        />
                    </VehicleOneValue>
                </VehicleOneSection>

                <VehicleOneSection>
                    <VehicleOneLabel>
                        {$_('Postal code')}
                    </VehicleOneLabel>
                    <VehicleOneValue>
                        <InputText
                            style="width: 100%; max-width: 220px;"
                            value={job.getData()?.address_attributes?.pcode || ''}
                            on:change={e => {
                                job.updateAddressAttributeValue('pcode', e.target?.value || '');
                                job = job;
                            }}
                            on:focusout={e => {
                                job.updateAddressAttributeValue('pcode', e.target?.value || '');
                                job = job;
                            }}
                        />
                    </VehicleOneValue>
                </VehicleOneSection>

                <VehicleOneSection>
                    <VehicleOneLabel>
                        {$_('province')}
                    </VehicleOneLabel>
                    <VehicleOneValue>
                        <InputText
                            style="width: 100%; max-width: 220px;"
                            value={job.getData()?.address_attributes?.province || ''}
                            on:change={e => {
                                job.updateAddressAttributeValue('province', e.target?.value || '');
                                job = job;
                            }}
                            on:focusout={e => {
                                job.updateAddressAttributeValue('province', e.target?.value || '');
                                job = job;
                            }}
                        />
                    </VehicleOneValue>
                </VehicleOneSection>

                <VehicleOneSection>
                    <VehicleOneLabel>
                        {$_('community')}
                    </VehicleOneLabel>
                    <VehicleOneValue>
                        <InputText
                            style="width: 100%; max-width: 220px;"
                            value={job.getData()?.address_attributes?.community || ''}
                            on:change={e => {
                                job.updateAddressAttributeValue('community', e.target?.value || '');
                                job = job;
                            }}
                            on:focusout={e => {
                                job.updateAddressAttributeValue('community', e.target?.value || '');
                                job = job;
                            }}
                        />
                    </VehicleOneValue>
                </VehicleOneSection>

                <VehicleOneSection>
                    <div style="display: flex; justify-content: space-between; align-items: center;">
                        <ButtonSmallBlue text={$_('Geocode')} on:click={geocode} disabled={geocodingInProgress} />
                        <ButtonSmallBlack text={$_('Set on the map')} on:click={startPointOnMap} disabled={geocodingInProgress} />
                    </div>
                </VehicleOneSection>
            </div>
        </VehicleOneParagraph>

        <div style="display: flex; justify-content: flex-end; margin:10px 40px; column-gap: 15px;align-items: center;">
            {#if savingError}
                <div style="padding: 0 30px;">
                    <TemplateRow justifyContent="flex-start">
                        <ErrorInline text={$_(savingError)} />
                    </TemplateRow>
                </div>
            {/if}
            {#if validateError.length > 0}
                <div style="padding: 0 30px;">
                    <TemplateRow justifyContent="flex-start">
                        <ErrorInline text={$_(validateError[0])} />
                    </TemplateRow>
                </div>
            {/if}
            {#if job.getData()?.geom && job.getData()?.geom?.coordinates}
                <IconLocationOn
                    on:click={() => {
                        console.log('job.geom', job.getData()?.geom);
                        if (job.getData()?.geom && job.getData()?.geom?.coordinates) {
                            Targeo.Base.Map.zoomAndCenter(
                                {
                                    x: job.getData()?.geom?.coordinates[0],
                                    y: job.getData()?.geom?.coordinates[1],
                                },
                                21
                            );
                            //jobsOnMap.jobShowBalloon(job.id);
                        }
                    }}
                />
            {:else if triedToSave && !saving}
                <div style="opacity:0.5; display: flex;">
                    <ErrorInline text={$_('No coordinates')} />
                    <ErrorColor>
                        <IconLocationOn />
                    </ErrorColor>
                </div>
            {/if}

            {#if validating || saving}
                <IconPending spin={true} scale={0.7} />
            {/if}
            {#if savedWithSuccess}
                <SuccessInline text={$_('Saved')} />
            {/if}
            <!--            <ButtonMain-->
            <!--                text={job.isManuallySetCoords() ? $_('Save') : $_('Save')}-->
            <!--                disabled={validating || saving || validateError.length !== 0}-->
            <!--                on:click={() => {-->
            <!--                    console.log('Saving job', job);-->
            <!--                    saveJob(!job.isManuallySetCoords() || job.getData().address_id === null);-->
            <!--                }}-->
            <!--            />-->
            <!--            <ButtonMain-->
            <!--                text={job.isManuallySetCoords() ? $_('Close') : $_('Close')}-->
            <!--                disabled={validating || saving || validateError.length !== 0}-->
            <!--                on:click={() => {-->
            <!--                    console.log('Closing');-->
            <!--                    // saveJob(!job.isManuallySetCoords() || job.getData().address_id === null);-->
            <!--                }}-->
            <!--            />-->
            <ButtonMain
                requiresWrite={true}
                text={job.isManuallySetCoords() ? $_('Save and close') : $_('Save and close')}
                disabled={validating || saving || validateError.length !== 0}
                on:click={() => {
                    console.log('Saving job', job);
                    saveJob();
                }}
            />
        </div>
    </div>
{/if}

{#if $debug}
    <pre>{JSON.stringify(job.getData(), null, 2)}</pre>
{/if}

<style>
    .job-edit-form {
        background-color: var(--section-background);
        border-radius: 6px;
        padding: 20px 0;
        margin: 10px 0;
    }
</style>
